// imports
import gsap from 'gsap';
import Component from 'minsky-kit/js/components/Component';
import { strToDom } from 'minsky-kit/js/utils/dom';
import Ticker from 'minsky-kit/js/managers/Ticker';

// private statics

// class definition
export default class WordFlipper extends Component {
    // constructor
    constructor (args = {}, objectName = 'WordFlipper') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // set properties
        this._$current = this.$el.querySelector('.word-flipper__word');
        this._$next = null;
        this._words = this.$el.dataset.words.split(',').map((w) => w.trim());
        this._timer = new Ticker({ timeout: 3000 });
        this._nextFrameTimer = new Ticker();
        this._index = 0;

        // add listners
        this._timer.on('timeout', this.blm.add('onTick', onTick));
        this._nextFrameTimer.on('timeout', this.blm.add('onNextFrame', onNextFrame));

        // add current word if not yet present in list
        const current = this._$current.innerText.trim();
        if (this._words.indexOf(current) === -1) this._words.unshift(current);

        // prep callback in blm
        this.blm.add('onTweenComplete', onTweenComplete);

        // start timer
        this._timer.start();
        this._nextFrameTimer.start();

        // set size
        updateElSize.call(this);
    }

    // methods
    next () {
        const wordHeight = this._$current.clientHeight;

        this._index = ++this._index % this._words.length;
        this._$next = renderWord(this._words[this._index]);
        this._$next.style.transform = `translateY(${-wordHeight}px)`;
        this._$el.append(this._$next);

        gsap.to(this._$current, { y: this._$current.clientHeight, duration: 0.5 });
        gsap.to(this._$next, {
            y: 0, duration: 0.5, onComplete: this.blm.get('onTweenComplete'),
        });

        this._nextFrameTimer.start(true);
    }

    refresh () {
        updateElSize.call(this);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils
function renderWord (word) {
    return strToDom(`<span class="word-flipper__word">${word}</span>`);
}

function updateElSize ($word) {
    $word = !$word ? this._$current : $word;

    // get curren word sizes
    this._$el.style.width = `${$word.scrollWidth}px`;
    // this._$el.style.height = `${$word.scrollHeight}px`;
}

// Event handlers
function onTick (e) {
    this.next();
}

function onTweenComplete () {
    this._$current.remove();
    this._$current = this._$next;
    this._$next = null;
    this._timer.start(true);
}

function onNextFrame () {
    updateElSize.call(this, this._$next);
}
